import '../styles/index.scss';
import React, { useEffect } from "react";
import AppLayout from '@amzn/meridian/app-layout';
import AppRouter from '../routing/AppRouter';
import ErrorModal from './ErrorModal';
import { alertsPolling } from '../services/alertsPolling';
import ThemeProvider from './ThemeProvider';

const App: React.FC = () => {
  useEffect(() => {
    // Start alerts polling when the app mounts
    alertsPolling.startPolling();

    // Cleanup: stop polling when the app unmounts
    return () => {
      alertsPolling.stopPolling();
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <ThemeProvider>
      <AppLayout>
        <AppRouter />
        <ErrorModal />
      </AppLayout>
    </ThemeProvider>
  );
}

export default App;
